import { useEffect } from 'react'
import { useQuery } from 'react-query'
import { liveStreamInfo } from '../../../services/get/getLiveSteamInfo'

const useLiveStreamInfos = (title, channelId) => {
  const query = useQuery({
    queryFn: () => liveStreamInfo(title, channelId),
    queryKey: 'live-stream-info',
    enabled: Boolean(title && channelId)
  })

  useEffect(() => () => query.remove(), [])

  return query
}

export { useLiveStreamInfos }
